import Modal from "components/Modal";
import { FormProvider } from "react-hook-form";
import Divider from "components/Divider";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import {
  ModalSecondaryAction,
  ModalPrimaryButton,
} from "pages/app/customer/AddFacility/AddFacilityModal";
import { DatePickerNew } from "components/DatePickerNew";
import { CreateTransportSedelLogicRetVal } from "./useCreateTransportSedelLogic";

type Props = {
  logic: CreateTransportSedelLogicRetVal;
  title: string;
  actionText?: string;
};
export const TransportSedelModal = ({
  logic,
  title,
  actionText = "Spara",
}: Props) => {
  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={title}
      actionText="Spara"
      onClose={logic.onModalClose}
      afterClose={logic.afterModalClose}
      isLoading={logic.mutation.isPending}
      hideButtons
      // isPrettyWide
    >
      <FormProvider {...logic.form}>
        <form className="mt-4 space-y-8 pt-4" onSubmit={logic.onSubmit}>
          <DropdownFormProvider
            items={logic.wasteStationDropdownItems}
            label="Mottagarstation"
            name="wasteStationUuid"
            hideClearButton
          />

          <DropdownFormProvider
            items={logic.vehicleDropdownItems}
            label="Fordon"
            name="vehicleUuid"
            hideClearButton
          />
          <div className="inline-block">
            <DatePickerNew
              name="timeOfDepartureUtc"
              label={"Tid för avfärd"}
              showTimeInput
              // inline
            />
          </div>

          <Divider className="mb-4 mt-6" />
          <div className="flex justify-end">
            <div className="flex w-full gap-x-2">
              <ModalSecondaryAction onClick={logic.onModalClose} />
              <ModalPrimaryButton
                isLoading={logic.mutation.isPending}
                buttonText={actionText}
                loadingText="Sparar"
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
